// 分页请求基类
export interface PageRequest {
  pageNum: number
  pageSize: number
  sort?: string
  paging?: boolean
  conditions?: QueryCondition[]
  sorts?: SortCondition[]
}

// 分页响应基类
export interface PageResponse<T> {
  records: T[]
  total: number
  size: number
  current: number
  pages: number
}

// 通用API响应格式
export interface ApiResponse<T = any> {
  success: boolean
  code: number
  message: string
  data: T
}

// 查询条件
// 使用示例：
// 1. 普通查询：{ fieldName: 'priceNo', operator: QueryOperator.EQ, value: 'FCL001' }
// 2. 日期快捷查询：{ fieldName: 'dateCreated', operator: QueryOperator.DATE_SHORTCUT, value: DateShortcutType.THIS_WEEK }
export interface QueryCondition {
  fieldName: string
  operator: QueryOperator
  value: any
}

// 排序条件
export interface SortCondition {
  fieldName: string
  order: 'ASC' | 'DESC'
}

// 查询操作符枚举
export enum QueryOperator {
  EQ = 'EQ', // 等于
  NE = 'NE', // 不等于
  GT = 'GT', // 大于
  GTE = 'GTE', // 大于等于
  LT = 'LT', // 小于
  LTE = 'LTE', // 小于等于
  LIKE = 'LIKE', // 模糊查询
  IN = 'IN', // 包含
  NOT_IN = 'NOT_IN', // 不包含
  BETWEEN = 'BETWEEN', // 范围查询
  IS_NULL = 'IS_NULL', // 为空
  IS_NOT_NULL = 'IS_NOT_NULL', // 不为空
  DATE_SHORTCUT = 'DATE_SHORTCUT' // 日期快捷操作 (配合 DateShortcutType 使用)
}

// 日期快捷类型枚举
// 配合 QueryOperator.DATE_SHORTCUT 使用
export enum DateShortcutType {
  // 周相关
  THIS_WEEK = 'THIS_WEEK',
  LAST_WEEK = 'LAST_WEEK',
  NEXT_WEEK = 'NEXT_WEEK',

  // 月相关
  THIS_MONTH = 'THIS_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  NEXT_MONTH = 'NEXT_MONTH',

  // 年相关
  THIS_YEAR = 'THIS_YEAR',
  LAST_YEAR = 'LAST_YEAR',
  NEXT_YEAR = 'NEXT_YEAR',

  // 其他常用快捷
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  TOMORROW = 'TOMORROW',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_90_DAYS = 'LAST_90_DAYS'
}